import { render } from "./BaseFormSubmit.vue?vue&type=template&id=b498931c&ts=true"
import script from "./BaseFormSubmit.vue?vue&type=script&lang=ts"
export * from "./BaseFormSubmit.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__